import { CommonModule } from '@angular/common'
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
  NgModule,
} from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'

import { TranslatePipe } from '@ngx-translate/core'
import { NgArrayPipesModule, NgPipesModule } from 'ngx-pipes'

import { ComponentsModule } from '../../components/components.module'
import { SharedModule } from '../../shared/shared.module'
import { ArticlesModule } from '../articles/articles.module'
import { EditionsModule } from '../editions/editions.module'
import { EditionComponentsModule } from './magazines-and-journals-detail-page/components/edition-components.module'
import { MagazinesAndJournalsRoutingModule } from './magazines-and-journals-routing.module'

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    MagazinesAndJournalsRoutingModule,
    ComponentsModule,
    NgArrayPipesModule,
    SharedModule,
    NgPipesModule,
    EditionComponentsModule,
    EditionsModule,
    ArticlesModule,
    TranslatePipe,
  ],
  exports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class MagazinesAndJournalModule {}
